var _defs, _path, _path2, _path3, _path4;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgProfileHomeLines = function SvgProfileHomeLines(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 174.87 64",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".profilehomelines{fill:current;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "profilehomelines",
    d: "M169.32,42c1.47,0,2.65-.89,2.65-2s-1.18-2-2.64-2H44.61c-1.46,0-2.64.9-2.64,2s1.19,2,2.64,2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "profilehomelines",
    d: "M168.53,59c1.9,0,3.44-.89,3.44-2s-1.53-2-3.43-2H6.41C4.5,55,3,55.91,3,57s1.54,2,3.44,2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "profilehomelines",
    d: "M167.88,25c2.26,0,4.09-.9,4.09-2s-1.83-2-4.09-2H85.06C82.8,21,81,21.9,81,23s1.83,2,4.09,2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "profilehomelines",
    d: "M169.23,8c1.51,0,2.74-.9,2.74-2s-1.23-2-2.74-2H113.71C112.2,4,111,4.9,111,6s1.23,2,2.74,2Z"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProfileHomeLines, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ProfileHomeLines.a9fb9b1f.svg";
export { ForwardRef as ReactComponent };